<app-page-header></app-page-header>
<app-breadcromb pageName="Manage Applications"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-12 dashboard-left-border">
                <div class="dashboard-left">
                    <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="dashboard-right">
                    <div class="manage-jobs">
                        <div class="manage-jobs-heading">
                            <h3>My Applications</h3>
                        </div>
                        <div class="single-manage-jobs table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Posted on</th>
                                        <th>Closing date</th>
                                        <th>Status</th>
                                        <th>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let application of applications">
                                        <td class="manage-jobs-title maxbreak"><a href="#" routerLink="/dashboard/browse-vacant/{{application.vacancy.id}}">{{application.vacancy.title}} </a></td>
                                        <td class="table-date">{{ application.vacancy.publishDate | date}} </td>
                                        <td class="table-date">{{ application.vacancy.closingDate | date}}</td>
                                        <td *ngIf="application.status == 'pending'"><span class="pending">Pending</span></td>
                                        <td *ngIf="application.status == 'declined' && application.vacancy.completeInterviews"><span class="expired">Unsuccessful</span></td>
                                        <td *ngIf="application.status == 'declined' && !application.vacancy.completeInterviews"><span class="expired">Pending</span></td>
                                        <td *ngIf="application.status == 'accepted'"><span class="accepted">Accepted</span></td>
                                        <td class="action">
                                            <div *ngIf="compareDates(application.vacancy.closingDate)"> <a [routerLink]="" (click)="deleteApplication(application.id)" class="action-delete"><i class="fa fa-trash-o"></i> Withdraw</a></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-box-row">
                                <p>Page 1 of 6 </p>
                                <ul class="pagination">
                                    <li class="active"><a href="#">1</a></li>
                                    <li><a href="#">2</a></li>
                                    <li><a href="#">3</a></li>
                                    <li>...</li>
                                    <li><a href="#">6</a></li>
                                    <li><a href="#"><i class="fa fa-angle-double-right"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Candidate Dashboard Area End -->
